module.exports = __webpack_public_path__ + "media/images/footer/ffa-1f484ee9b7dac0e98b6d5bfe40caf976.png";